export default __webpack_public_path__ + "static/media/payments-customer.8f7c8019.jpg";